export default __webpack_public_path__ + "static/media/Icon awesome-linkedin-in.b1ab8c51.svg";